import React from 'react'
import BaseComponent from './BaseComponent'

export default class extends BaseComponent {

  constructor(props) {
    super(props)
    this.state = { login: "", pass: "", loginError: false, passError: false, error: false, anim: false }
    this._bind('handleInputChange', 'checkLogin', 'processLogin', 'onPressEnter')
  }

  componentDidMount() {
  	document.addEventListener("keyup", this.onPressEnter )
    setTimeout(() => { this.setState({ anim: true }) }, 200)

    document.getElementById('login').focus()
  }

  componentWillUnmount() {
    document.removeEventListener("keyup", this.onPressEnter )
  }

  onPressEnter(event) {
    event.preventDefault()
    if (event.keyCode === 13) {
      document.getElementById("button").click()
    }
  }

  handleInputChange(event) {
	const target = event.target
	let value = target.type === 'checkbox' ? target.checked : target.value
	let name = target.name

	this.setState({
	  [name]: value
	})

	if (name === "login" && name !== "") {
		this.setState({ loginError: false })
	}

	if (name === "pass" && name !== "") {
		this.setState({ passError: false })
	}
  }

  checkLogin() {
  	if (this.state.login === "") {
  		document.getElementById('login').focus()
  		this.setState({ loginError: true })
  	}

  	if (this.state.login !== "" && this.state.pass === "") {
  		document.getElementById('pass').focus()
  		this.setState({ passError: true })
  	}

  	if (this.state.login !== "" && this.state.pass !== "") {
  		this.processLogin()
  	}
  }

  processLogin() {
  	// if (this.state.login === "admin" && this.state.pass === "admin") {
  	// 	this.props.loginSuccess()
   //    window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "green", 'content' : "Pomyślnie zalogowano."}}), true);
  	// } else {
  	// 	this.setState({ error: true, login: "", pass: "" })
  	// 	document.getElementById('login').focus()
   //    window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : "Coś poszło nie tak."}}), true);
  	// }
    let data  = { login: this.state.login, password: this.state.pass }
    fetch(this.props.API+"/auth/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: JSON.stringify(data)
    })
    .then((response) => {
        return response.json()
    })
    .then((result) => {
      if (!result.data.status) {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : result.data.flag === "E_NO_AUTH" ? "Niepoprawne dane" : "Coś poszło nie tak." }}), true);
      } else {
        window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "green", 'content' : "Pomyślnie zalogowano."}}), true);
      }
        if (result.data.status === true) {
          sessionStorage.setItem('token', result.data.result.access_token)
          this.props.loginSuccess(result.data.result)
        } else {
          this.setState({ error: true, login: "", pass: "" })
          document.getElementById('login').focus()
        }
    }, (error) => {
      console.log(error)
      window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : "Coś poszło nie tak."}}), true);
    })
  }

  render() {

    return (
      <section className="login">
        <div className={ this.state.anim ? "login-box show" : "login-box" }>
          <img className="login-logo" src="/assets/img/logo-blue.png" alt="WMS Logo"/>
        	<h3>Logowanie do systemu</h3>
        	<div className="inputs">
        		{ this.state.error ? <p className="error">Niepoprawne dane logowania!</p> : null }
        		<input type="text" name="login" id="login" placeholder="Nazwa użytkownika" value={ this.state.login } onChange={ this.handleInputChange } required/>
        		{ this.state.loginError ? <p className="error">Podaj nazwę użytkownika</p> : null }
        		<input type="password" name="pass" id="pass" placeholder="Hasło" value={ this.state.pass } onChange={ this.handleInputChange } required/>
        		{ this.state.passError ? <p className="error">Podaj hasło</p> : null }
        		<div className="btn-holder">
        			<button className="btn btn-login" id="button" onClick={ this.checkLogin }><span>Zaloguj się&nbsp;&nbsp;></span></button>
        		</div>
        	</div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/LoginPage.js